import React            from 'react';
import { useDraggable } from '@dnd-kit/core';
import Tens             from 'components/Tens';
import Button           from 'components/buttons/DisplayEggBoxButton';
import box_0            from 'images/box_0.png';
import box_1            from 'images/box_1.png';
import box_2            from 'images/box_2.png';
import box_3            from 'images/box_3.png';
import box_4            from 'images/box_4.png';
import box_5            from 'images/box_5.png';
import box_6            from 'images/box_6.png';
import box_7            from 'images/box_7.png';
import box_8            from 'images/box_8.png';
import box_9            from 'images/box_9.png';
import box_10           from 'images/box_10.png';
import closedBox        from 'images/closedBox.png';
import sizes            from 'utils/sizes';
//import FitScreenIcon    from '@mui/icons-material/FitScreen';

import { makeStyles/* , theme */ } from "makeStyles";

//var clsx = require('classnames')


const useStyles = makeStyles()(
    (theme) => ({
    root: {
        width:              '100%',
        height:             '100%',
        backgroundPosition: 'center',
        backgroundSize:     'contain',
        backgroundRepeat:   'no-repeat',
        display:            'flex',
        alignItems:         'center',
        flexFlow:           'column',
        touchAction:        'manipulation',

    },
    mockBox: {
      position: 'absolute'
    },
    button: {
      position:       'absolute',
      width:          40,
      height:         30,
      display:        'flex',
      alignItems:     'center',
      justifyContent: 'center',
      color:          theme.blue,
      background:     '#FFF',
      borderRadius:   '0.4em',
      left:           -70,
      top:            0,
      cursor:         'pointer',
      border:         `1px solid ${ theme.blue }`,
      boxShadow:      '2px 3px 4px rgba(0,0,0,0.1)',
      '&:hover': {
        background: '#EEF'
      }
    }
  })
);

type EggBoxProps = {
    value:       number;
    variant?:    string;
    showButton?: boolean;
    wideScreen:  boolean;
    showClosed:  boolean;
}

const EggBox: React.FC<EggBoxProps> = ({ 
  value,
  variant,
  showButton,
  wideScreen, 
  showClosed,
}) => {

  const { classes } = useStyles();

  const arr = React.useMemo(() => {
    const arr_ = [box_0, box_1, box_2, box_3, box_4, box_5, box_6, box_7, box_8, box_9];
    if ( showClosed ) {
      arr_.push(closedBox)
    }
    else {
      arr_.push(box_10)
    }
    return arr_;
  },[showClosed])


  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: `${ value }`
  });


  const [rootStyle ,daggableStyle] = React.useMemo(() => {

      const { 
        bigBoxWidth, 
        bigBoxHeight, 
        smallBoxHeight 
      } = sizes;

      const width          = wideScreen ? bigBoxWidth : '19vw';
      const height         = wideScreen ? bigBoxHeight : smallBoxHeight;
      const backgroundImg  = ( !!variant && variant === 'tens' ) ? ( value === 1 ? `url(${ closedBox })` : 'none' ) : `url(${ arr[value] })`;

      const style = {
        backgroundImage: backgroundImg,
        width:           width,
        minWidth:        width,
        height:          height,
        minHeight:       height,
      }

      return [
        style,
        {
          ...style,
          transform: `translate3d(${ !!transform ? transform.x : 0 }px, ${ !!transform ? transform.y : 0 }px, 0px)`,
          zIndex:    !!transform ? 1 : 0
        }
       ]
  },[value, variant, arr, transform, wideScreen])

  
  return (
     <div 
       className = { classes.root }
       style     = { rootStyle }
     >
      <div 
          className    = { classes.root }
          style        = { daggableStyle }
          ref          = { setNodeRef } 
          { ...listeners } 
          { ...attributes }
      >
         {
          !!variant && variant === 'tens' && value > 1 &&
          <>
            <Tens
              value      = { value } 
              wideScreen = { wideScreen } 
              position   = ''
            />
            {
              showButton &&
              <Button
                 variant    = { 'input' }
                 value      = { value }
                 wideScreen = { wideScreen }
              />
            }
           </>
         } 
      </div>
     </div>
  );
}



export default EggBox;








